<!-- Delete confirmation modal -->
@if (opened) {
    <div class="k-overlay"></div>
}
@if (opened) {
    <kendo-window class="wk-dialog-confirmation" [resizable]="false" (close)="close()" [draggable]="false">
        <kendo-window-titlebar class="wk-av__delete--bc">
            <div class="k-window-title">{{ "AllView.Events.DeleteConfirmationTitle" | translate }}</div>
            <wk-icon-filled-close-sprite-pds3 />
            <icon-pds3 name="wk-icon-filled-close" (click)="close()" />
        </kendo-window-titlebar>
        <div class="k-win-content wk-av__delete--ws">
            @if (isJobsBillingDashboard) {
                {{ "AllView.Events.DeleteConfirmationMessage_JobsBilling" | translate: { count: CurrentDeletionCount.length } }}
            } @else {
                {{ "AllView.Events.DeleteConfirmationMsg_Initial" | translate }} {{ CurrentDeletionCount.length }}
                {{ "AllView.Events.DeleteConfirmationMsg_Last" | translate }}
            }
        </div>
        <div class="k-actions k-actions-end">
            <button type="button" class="btn-primary red wk-av__delete--bc" (click)="handleDelete()">
                <span aria-hidden="true">{{ "General.Delete" | translate }}</span>
            </button>
            <button type="button" class="btn-secondary" (click)="close()">
                <span aria-hidden="true">{{ "General.Cancel" | translate }}</span>
            </button>
        </div>
    </kendo-window>
}

<!-- Export confirmation modal -->
@if (isExportPopupOpened) {
    <div class="k-overlay"></div>
}
@if (isExportPopupOpened) {
    <kendo-window class="wk-dialog-confirmation" [resizable]="false" (close)="close_ExportPopup()" [draggable]="false">
        <kendo-window-titlebar class="wk-av__export--background">
            <div class="k-window-title">{{ "Export.CsvReportTitle" | translate }}</div>
            <wk-icon-filled-close-sprite-pds3 />
            <icon-pds3 name="wk-icon-filled-close" (click)="close_ExportPopup()" />
        </kendo-window-titlebar>
        <div class="k-win-content wk-av__export--ws">
            {{ "Export.CsvReportMsg" | translate }}
        </div>
        <div class="k-actions k-actions-end">
            <button type="button" class="btn-primary blue wk-av__export--bc" (click)="exportView()">
                <span aria-hidden="true">{{ "General.Export" | translate }}</span>
            </button>
            <button type="button" class="btn-secondary" (click)="close_ExportPopup()">
                <span aria-hidden="true">{{ "General.Cancel" | translate }}</span>
            </button>
        </div>
    </kendo-window>
}

<!-- Grid settings popover -->
<kendo-popover #allViewSettingPopover position="bottom" class="popoverClass wk-av__sp" (shown)="onShown($event)">
    <ng-template kendoPopoverBodyTemplate>
        <div class="wk-av__body-template">
            <div (click)="onResetColumnHandler()" class="wk-av__reset-column-order">
                <span class="bold wk-av__reset-column-order--span">{{ "AllView.ResetColumnOrder" | translate }}</span>
            </div>
            <hr class="wk-av__body-template--hr" />
            <wk-icon-search-sprite-pds3 />
            <search-field-pds3
                size="medium"
                searchButtonId="search-column"
                class="wk-av__search-column"
                (clear)="onSearchClearInput()"
                (search)="onSearchButtonClick($event)"
            >
                <input type="search" autocomplete="off" #searchInput (input)="onSearchInput($event)" />
            </search-field-pds3>
            <div class="wk-av__tooltip">
                <div kendoTooltip showOn="none" [tooltipTemplate]="template" (mouseover)="showSettingPopoverTooltip($event)">
                    @for (item of settingPagedItems; track item) {
                        <ul class="wk-av__tooltip--ul">
                            <label class="wk-av__tooltip--label">
                                <input
                                    type="checkbox"
                                    [(ngModel)]="item.selected"
                                    (click)="onColumnVisibilityChange($event)"
                                    class="wk-av__tooltip--input"
                                />
                                {{ item.label }}
                            </label>
                        </ul>
                    }
                </div>
            </div>
            @if (maxSettingPageSize > 1) {
                <wk-pagination-component
                    class="wk-pagination"
                    #pagination
                    [collectionSize]="totalItemsCount"
                    [pageSize]="settingPageSize"
                    [firstLastButtons]="false"
                    [currentPage]="settingPageNumber"
                    (pageChange)="onSettingPageChange($event)"
                />
            }
        </div>
    </ng-template>
</kendo-popover>

<div id="virtual-scroller-wrapper" class="wk-av__virtual-scroller--wrapper wk-av__card-list">
    <ng-template #template let-anchor>
        <span>{{ anchor.nativeElement.innerText }}</span>
    </ng-template>
    <div
        kendoTooltip
        showOn="none"
        [tooltipTemplate]="template"
        filter=".k-grid td"
        (mouseover)="showTooltip($event)"
        class="wk-av__card-list--height all-view-grid-wrapper"
        [class.grid-data-not-available]="!isGridDataAvailable"
    >
        <kendo-grid
            class="wk-av__card-list--height"
            [reorderable]="true"
            [selectable]="{ enabled: true, checkboxOnly: true }"
            kendoGridSelectBy="CardId"
            [(selectedKeys)]="mySelection"
            (selectedKeysChange)="onSelectedKeysChange()"
            [data]="gridData()"
            [loading]="loading"
            [skip]="skip"
            [pageSize]="pageSize"
            scrollable="virtual"
            [rowHeight]="36"
            (pageChange)="pageChange($event)"
            [sortable]="{ allowUnsort: false }"
            (cellClick)="cellClickHandler($event)"
            [sort]="sort"
            (sortChange)="onSortChange($event)"
            (columnReorder)="columnReorderHandler($event)"
        >
            <!-- Header toolbar above the grid -->
            <ng-template kendoGridToolbarTemplate>
                @if (this.mySelection.length > 0) {
                    <button kendoButton class="wk-av__card-list--k-button" (click)="clearSelection()">
                        @if (this.mySelection.length === 1) {
                            <span>
                                {{ mySelection.length }} {{ "AllView.SingleCardSelectedTitle" | translate }}
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </span>
                        }
                        @if (this.mySelection.length > 1) {
                            <span>
                                {{ mySelection.length }} {{ "AllView.MultipleCardSelectedTitle" | translate }}
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </span>
                        }
                    </button>
                }

                <button-field-pds3 type="secondary" class="wk-av__card-list--push-right">
                    <button id="actions-menu-button">
                        <wk-icon-menu-sprite-pds3 />
                        <icon-pds3 name="wk-icon-menu"></icon-pds3>
                        {{ "AllView.Actions" | translate }}
                    </button>
                </button-field-pds3>

                <dropdown-pds3 targetSelector="#actions-menu-button" class="dropdown-container">
                    <wk-icon-export-sprite-pds3 />
                    <wk-icon-trash-sprite-pds3 />
                    <wk-icon-repeat-sprite-pds3 />
                    <dropdown-list-pds3>
                        @if (userCanPrintExport) {
                            <dropdown-item-field-pds3 *dropdownListItemPds3>
                                <button type="button" (click)="open_ExportPopup()">
                                    <icon-pds3 name="wk-icon-export"></icon-pds3>
                                    {{ "General.Export" | translate }}
                                </button>
                            </dropdown-item-field-pds3>
                        }

                        @if (userCanDeleteCard) {
                            <dropdown-item-field-pds3 [isDisabled]="this.mySelection?.length === 0" *dropdownListItemPds3>
                                <button type="button" [disabled]="this.mySelection?.length === 0" (click)="open()">
                                    <icon-pds3 name="wk-icon-trash"></icon-pds3>
                                    {{ "General.Delete" | translate }}
                                </button>
                            </dropdown-item-field-pds3>
                        }

                        @if (userCanBulkChange) {
                            <dropdown-item-field-pds3 [isDisabled]="this.mySelection?.length === 0" *dropdownListItemPds3>
                                <button type="button" [disabled]="this.mySelection?.length === 0" (click)="openBulkChange()">
                                    <icon-pds3 name="wk-icon-repeat"></icon-pds3>
                                    {{ "BulkChange.BulkChange" | translate }}
                                </button>
                            </dropdown-item-field-pds3>
                        }
                    </dropdown-list-pds3>
                </dropdown-pds3>

                <button
                    kendoButton
                    (click)="onShow(popupAnchor)"
                    kendoPopoverContainer
                    #popoverContainer="kendoPopoverContainer"
                    [popover]="allViewSettingPopover"
                >
                    <div #popupAnchor>
                        <wk-icon-filled-settings-sprite-pds3 />
                        <icon-pds3 name="wk-icon-filled-settings" />
                    </div>
                </button>
            </ng-template>

            <!-- Grid columns -->
            <kendo-grid-checkbox-column [width]="40" [locked]="true" headerClass="wk-av__columns--bc" [reorderable]="false">
                <ng-template kendoGridHeaderTemplate>
                    <kendo-checkbox kendoGridSelectAllCheckbox [state]="selectAllState" (selectAllChange)="onSelectAllChange($event)" />
                </ng-template>
            </kendo-grid-checkbox-column>

            <kendo-grid-column
                field="ClientCode"
                [width]="170"
                [locked]="true"
                [reorderable]="false"
                headerClass="wk-av__columns--bc"
                title="{{ 'AllView.ClientCode' | translate }}"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    @if (dataItem.ClientCode[clientCodeToUse]) {
                        <span> {{ dataItem.ClientCode[clientCodeToUse] }} </span>
                    }
                </ng-template>
            </kendo-grid-column>

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column field="ClientFileCount" [locked]="true" [reorderable]="false" headerClass="wk-av__columns--bc" [width]="50">
                    <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                        <i class="fa fa-user wk-taxpayer-count wk-av__columns--i" aria-hidden="true"></i>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.CalcFields.clientFileCount }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="JobID"
                    [locked]="true"
                    [reorderable]="false"
                    headerClass="wk-av__columns--bc"
                    [width]="80"
                    title="{{ 'AllView.JobID' | translate }}"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.JobID }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            <kendo-grid-column
                field="ClientName"
                [width]="200"
                [locked]="true"
                [reorderable]="false"
                headerClass="wk-av__columns--bc"
                title="{{ 'AllView.ClientName' | translate }}"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    @if (!dashboardsService.isJobsBilling()) {
                        @if (dataItem.VIP) {
                            <div class="wk-av__columns--head-vip">VIP</div>
                        }
                        @if (dataItem.CalcFields.documentReceivedLate) {
                            <i
                                placement="right"
                                [tooltip]="'NotStarted.DocumentsReceivedLate' | translate"
                                container="body"
                                class="fa fa-exclamation-triangle wk-av__columns--warning wk-av__columns--i--padding-right"
                                aria-hidden="true"
                            ></i>
                        }
                        @if (dataItem.CalcFields.isEFileStatusAlert) {
                            <i
                                placement="right"
                                [tooltip]="'CompletedView.TaxReturnNotCompletedAccordingToEFILE' | translate"
                                container="body"
                                class="fa fa-exclamation-triangle wk-av__columns--warning wk-av__columns--i--padding-right"
                                aria-hidden="true"
                            ></i>
                        }
                    }
                    {{ dataItem.ClientName }}
                </ng-template>
            </kendo-grid-column>

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column field="ReturnType" [width]="170" headerClass="wk-av__columns--bc" title="{{ 'AllView.FamilyMember' | translate }}">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span>{{ "Board." + dataItem.return.type | translate }}</span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column field="JobType" headerClass="wk-av__columns--bc" [width]="150" title="{{ 'AllView.JobType' | translate }}">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.JobType }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            <kendo-grid-column
                field="ReturnStatus"
                headerClass="wk-av__columns--bc"
                [width]="150"
                title="{{ (!dashboardsService.isJobsBilling() ? 'AllView.ReturnStatus' : 'AllView.JobStatus') | translate }}"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span> {{ dataItem.ReturnStatus | wkTranslate }} </span>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="Step" [width]="170" headerClass="wk-av__columns--bc" title="{{ 'AllView.Step' | translate }}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{ dataItem.Step | wkTranslate }}</span>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column
                field="DaysSinceInStep"
                [width]="170"
                [sortable]="true"
                headerClass="wk-av__columns--bc"
                title="{{ 'AllView.DaysInStep' | translate }}"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span> {{ dataItem.CalcFields.daysSinceInStep }} {{ "CardModal.Days" | translate }}</span>
                </ng-template>
            </kendo-grid-column>

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="Priority"
                    [width]="170"
                    [sortable]="true"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'JobsAndBilling.Priorities.Priority' | translate }}"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.Priority }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="ContactPartner"
                    [width]="170"
                    [sortable]="true"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'JobsAndBilling.Contact.Partner' | translate }}"
                    [hidden]="true"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.ContactPartner }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="ContactManager"
                    [width]="170"
                    [sortable]="true"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'JobsAndBilling.Contact.Manager' | translate }}"
                    [hidden]="true"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.ContactManager }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="CurrentlyResponsible"
                    [width]="170"
                    [sortable]="true"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'JobsAndBilling.AssignedRoles.CurrentlyResponsible' | translate }}"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.CurrentlyResponsible }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="JobPartner"
                    [width]="170"
                    [sortable]="true"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'JobsAndBilling.AssignedRoles.JobPartner' | translate }}"
                    [hidden]="true"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.JobPartner }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="JobManager"
                    [width]="170"
                    [sortable]="true"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'JobsAndBilling.AssignedRoles.JobManager' | translate }}"
                    [hidden]="true"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.JobManager }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="JobOwner"
                    [width]="170"
                    [sortable]="true"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'JobsAndBilling.AssignedRoles.JobOwner' | translate }}"
                    [hidden]="true"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.JobOwner }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column field="Category" [width]="170" headerClass="wk-av__columns--bc" title="{{ 'AllView.Category' | translate }}">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.Category === "Unassigned") {
                            <span> {{ "General.Unassigned" | translate }} </span>
                        }
                        @if (dataItem.Category != null && dataItem.Category !== "Unassigned") {
                            <span> {{ dataItem.Category | wkTranslate }} </span>
                        }
                    </ng-template>
                </kendo-grid-column>
            }

            @if (!dashboardsService.isJobsBilling()) {
                @for (column of columns; track column) {
                    <kendo-grid-column
                        field="{{ 'RoleUserMapping_' + column.RoleId }}"
                        title="{{ column.RoleName }}"
                        [width]="220"
                        headerClass="wk-av__columns--bc"
                    >
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span>{{ getRoleData(dataItem.RoleUserMapping, column.RoleId) }}</span>
                        </ng-template>
                    </kendo-grid-column>
                }
            }

            @if (isGroup1Enabled) {
                @let group1 = dashboardsService.isJobsBilling() ? ("JobsAndBilling.Contact.Title" | translate) + " " + Group1 : Group1;
                <kendo-grid-column field="ContactGroup1Option" [width]="170" headerClass="wk-av__columns--bc" title="{{ group1 }}" [hidden]="true">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.ContactGroup1Option) {
                            <span>{{ dataItem.ContactGroup1Option }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
            }
            @if (isGroup2Enabled) {
                @let group2 = dashboardsService.isJobsBilling() ? ("JobsAndBilling.Contact.Title" | translate) + " " + Group2 : Group2;
                <kendo-grid-column field="ContactGroup2Option" [width]="170" headerClass="wk-av__columns--bc" title="{{ group2 }}" [hidden]="true">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.ContactGroup2Option) {
                            <span>{{ dataItem.ContactGroup2Option }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling() && isJobsGroup1Enabled) {
                <kendo-grid-column
                    field="JobGroup1Option"
                    [width]="170"
                    headerClass="wk-av__columns--bc"
                    title="{{ ('JobsAndBilling.Job' | translate) + ' ' + Group1 }}"
                    [hidden]="true"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.JobGroup1Option) {
                            <span>{{ dataItem.JobGroup1Option }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
            }
            @if (dashboardsService.isJobsBilling() && isJobsGroup2Enabled) {
                <kendo-grid-column
                    field="JobGroup2Option"
                    [width]="170"
                    headerClass="wk-av__columns--bc"
                    title="{{ ('JobsAndBilling.Job' | translate) + ' ' + Group2 }}"
                    [hidden]="true"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.JobGroup2Option) {
                            <span>{{ dataItem.JobGroup2Option }}</span>
                        }
                    </ng-template>
                </kendo-grid-column>
            }

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column field="T1" [width]="170" headerClass="wk-av__columns--bc" title="{{ 'AllView.T1EFILE' | translate }}">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.t1 | wkTranslate }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column field="TP1" [width]="170" headerClass="wk-av__columns--bc" title="{{ 'AllView.TP1EFILE' | translate }}">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.tp1 | wkTranslate }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            <kendo-grid-column
                field="TimeStamp"
                [width]="170"
                headerClass="wk-av__columns--bc-important"
                title="{{ 'AllView.DateModified' | translate }}"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span> {{ dataItem.TimeStamp }} </span>
                </ng-template>
            </kendo-grid-column>

            @if (!dashboardsService.isJobsBilling() && ShowLastYearReceivedDate) {
                <kendo-grid-column
                    field="LastYearDocumentsReceivedDate"
                    [width]="170"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'AllView.LastYearReceivedDate' | translate }}"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.LastYearDocumentsReceivedDate) {
                            <span>
                                {{
                                    dataItem.LastYearDocumentsReceivedDate * 1000
                                        | date: (currentLanguage === "en-CA" ? "MMMM d, yyyy" : "d MMMM yyyy") : "" : currentLanguage
                                }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="TargetStartDate"
                    [width]="170"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'JobsAndBilling.TargetStartDate' | translate }}"
                    [hidden]="true"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.TargetStartDate }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="TargetEndDate"
                    [width]="170"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'JobsAndBilling.TargetEndDate' | translate }}"
                    [hidden]="true"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.TargetEndDate }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="PeriodEndDate"
                    [width]="170"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'FiltersSidebar.Labels.PeriodEnd' | translate }}"
                    [hidden]="true"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.PeriodEndDate }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            <kendo-grid-column
                field="DateReceived"
                [width]="170"
                headerClass="wk-av__columns--bc"
                title="{{ 'AllView.DateReceived' | translate }}"
                [hidden]="dashboardsService.isJobsBilling()"
            >
                <ng-template kendoGridCellTemplate let-dataItem>
                    @if (dataItem.DateReceived) {
                        <span>{{ dataItem.DateReceived }}</span>
                    }
                </ng-template>
            </kendo-grid-column>

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column field="DateNeeded" [width]="170" headerClass="wk-av__columns--bc" title="{{ 'AllView.DateNeeded' | translate }}">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.DateNeeded) {
                            <span>
                                {{
                                    dataItem.DateNeeded * 1000
                                        | date: (currentLanguage === "en-CA" ? "MMMM d, yyyy" : "d MMMM yyyy") : "" : currentLanguage
                                }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
            }

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column field="Deadline" [width]="170" headerClass="wk-av__columns--bc" title="{{ 'AllView.Deadline' | translate }}">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.Deadline) {
                            <span>
                                {{
                                    dataItem.Deadline * 1000
                                        | date: (currentLanguage === "en-CA" ? "MMMM d, yyyy" : "d MMMM yyyy") : "" : currentLanguage
                                }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
            }

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="DeliveryMethod"
                    [width]="170"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'AllView.DeliveryMethod' | translate }}"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.DeliveryMethod }} </span>
                    </ng-template>
                </kendo-grid-column>
            }

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="ThisYearCompletionDateTimestamp"
                    [width]="170"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'AllView.ThisYearCompletionDate' | translate }}"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.CalcFields.thisYearCompletionDateTimestamp) {
                            <span>
                                {{
                                    dataItem.CalcFields.thisYearCompletionDateTimestamp * 1000
                                        | date: (currentLanguage === "en-CA" ? "MMMM d, yyyy" : "d MMMM yyyy") : "" : currentLanguage
                                }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
            }

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="LastYearCompletedDate"
                    [width]="170"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'AllView.LastYearCompletionDate' | translate }}"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        @if (dataItem.LastYearCompletedDate) {
                            <span>
                                {{
                                    dataItem.LastYearCompletedDate * 1000
                                        | date: (currentLanguage === "en-CA" ? "MMMM d, yyyy" : "d MMMM yyyy") : "" : currentLanguage
                                }}
                            </span>
                        }
                    </ng-template>
                </kendo-grid-column>
            }

            @if (!dashboardsService.isJobsBilling()) {
                <kendo-grid-column
                    field="DaysSinceReady"
                    [width]="170"
                    headerClass="wk-av__columns--bc"
                    title="{{ 'AllView.WorkCycleTime' | translate }}"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span> {{ dataItem.CalcFields.daysSinceReady }} {{ "CardModal.Days" | translate }}</span>
                    </ng-template>
                </kendo-grid-column>
            }
            <ng-template kendoGridNoRecordsTemplate>
                <div></div>
            </ng-template>
        </kendo-grid>
    </div>
</div>

<div class="wk-av__cvc">
    @if (currentCounter > 1) {
        <span class="wk-av__cvc--text">{{ currentCounter }} {{ "AllView.Taxpayers" | translate }} </span>
    }
    @if (currentCounter <= 1) {
        <span class="wk-av__cvc--text">{{ currentCounter }} {{ "AllView.Taxpayer" | translate }} </span>
    }
</div>
<div kendoDialogContainer></div>

<!-- Router outlet to display card modal -->
<router-outlet></router-outlet>

@if (isBulkChangeOpen()) {
    <wk-bulkchange (closeModal)="handleBulkChangeClose()" />
}
